import { BrowserRouter, Route, Routes } from "react-router-dom";
import Landing from "../../pages/Landing";
import LoginForm from "../../components/LoginForm";
import SignupForm from "../../components/SignupForm";
import Home from "../../pages/home";
import Dashboard from "../../dashboard/Dashboard";
import StudentDashboard from "../../dashboard/Student/StudentDashboard";
import TeacherDashboard from "../../dashboard/Teacher/TeacherDashboard";
import { AuthProvider } from "../AuthContext";
import { AdminRoute, StudentRoute, TeacherRoute } from "../ProtectedRoute";

export function AppRouter() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />

          {/* Public role-based auth (navbar links) */}
          <Route path="/login/student" element={<LoginForm role="student" />} />
          <Route path="/login/teacher" element={<LoginForm role="teacher" />} />
          <Route path="/signup/student" element={<SignupForm role="student" />} />
          <Route path="/signup/teacher" element={<SignupForm role="teacher" />} />

          {/* Admin-only login (unlisted, not in navbar) */}
          <Route path="/admin-login" element={<Home />} />

          {/* Protected dashboards */}
          <Route
            path="/dashboard/*"
            element={
              <AdminRoute>
                <Dashboard />
              </AdminRoute>
            }
          />
          <Route
            path="/student-dashboard"
            element={
              <StudentRoute>
                <StudentDashboard />
              </StudentRoute>
            }
          />
          <Route
            path="/teacher-dashboard"
            element={
              <TeacherRoute>
                <TeacherDashboard />
              </TeacherRoute>
            }
          />

          <Route path="*" element={<Landing />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
